import classNames from "classnames";
import { FC, ReactNode, useCallback } from "react";
import { Classes } from "../components/classes";
import { Icons } from "../components/icons";
import { Page } from "../components/page";

const First: FC = () => {
    const handleOpenLink = useCallback(() => {
        window.open("https://whodb.com", "_blank");
    }, []);

    const handleOpenDocucodLink = useCallback(() => {
        window.open("https://docucod.com", "_blank");
    }, []);

    return <div className="flex flex-col gap-32 mt-[25vh] max-md:mt-[10vh] h-[60vh] max-md:h-full">
        <div className="flex gap-32 max-md:flex-col max-md:gap-16 min-h-[350px]">
            <div className="flex flex-col gap-8 flex-1">
                <div className={classNames(Classes.GradientText, "text-6xl max-md:text-5xl font-semibold pt-4")}>
                    Building software for <span className="text-[#bf853e]">people</span>.
                </div>

                <div className={classNames(Classes.GradientText, "text-xl max-md:text-xl font-semibold pt-4")}>
                    We're a tight-knit team of developers with a passion for crafting software people love to use.
                </div>
            </div>
            <div className="flex flex-col gap-4 flex-1">
                <div className={classNames(Classes.GradientText, "text-2xl")}>
                    Check our latest and greatest
                </div>

                <div className="group/command dark:bg-white/5 pl-8 pr-16 py-6 rounded-lg cursor-pointer relative hover:bg-white/15" onClick={handleOpenDocucodLink}>
                    <div className="flex items-center gap-6">
                        <div className="rounded-lg w-20 h-20 flex items-center justify-center">
                            <img src="/images/docucod-logo.svg" alt="Docucod Logo" className="h-20 w-20" />
                        </div>
                        <div className="flex flex-col">
                            <div className="text-xl text-white">
                                Docucod
                            </div>
                            <div className="text-base text-white">
                                Docucod automatically generates and maintains complete, always-up-to-date documentation—straight from your codebase.
                            </div>
                        </div>
                    </div>
                    <div className={classNames("absolute right-6 top-1/2 -translate-y-1/2 transition-all opacity-0 group-hover/command:opacity-100 z-10", Classes.Text)}>
                        {Icons.RightArrowUp}
                    </div>
                </div>

                <div className="h-16" /> {/* Increased spacing */}

                <div className={classNames(Classes.GradientText, "text-2xl")}>
                    We love open source
                </div>
                <div className="group/command dark:bg-white/5 pl-8 pr-16 py-6 rounded-lg cursor-pointer relative hover:bg-white/15" onClick={handleOpenLink}>
                    <div className="flex items-center gap-6">
                        <div className="rounded-lg w-16 h-16 flex items-center justify-center">
                            <img src="/images/whodb-logo.png" alt="WhoDB Logo" className="h-14 w-14" />
                        </div>
                        <div className="flex flex-col">
                            <div className="text-xl text-white">
                                WhoDB
                            </div>
                            <div className="text-base text-white">
                                The easiest way to ask questions and get answers from your databases.
                            </div>
                        </div>
                    </div>
                    <div className={classNames("absolute right-6 top-1/2 -translate-y-1/2 transition-all opacity-0 group-hover/command:opacity-100 z-10", Classes.Text)}>
                        {Icons.RightArrowUp}
                    </div>
                </div>
            </div>
        </div>
        <div className="flex items-center text-center max-md:justify-center">
            <div className={classNames(Classes.GradientText, "mr-2 text-xs font-medium")}>Backed by</div>
            <img src="/images/yc.png" alt="Y Combinator Startup Program" className="h-7" />
        </div>
    </div>
}

const Link: FC<{ children: ReactNode, to: string }> = ({ to, children }) => <div className={classNames(Classes.Text, "text-sm hover:brightness-50 cursor-pointer")} onClick={() => window.open(to, "_blank")}>
    {children}
</div>

const Footer = () => <div className="pt-[10vh] flex flex-col gap-8 self-center h-[200px] max-md:h-full max-md:pb-[10vh] w-full">
    <div className="flex max-md:flex-col justify-between items-center">
        <div className={classNames(Classes.Text, "text-sm")}>
            Clidey, Inc. All Rights Reserved.
        </div>
        <div className="flex max-md:flex-col gap-8 items-center max-md:mt-[5vh]">
            <Link to="https://linkedin.com/company/clidey/">LinkedIn</Link>
            <Link to="https://x.com/clideyofficial">Twitter/X</Link>
            <Link to="https://instagram.com/clideyofficial">Instagram</Link>
        </div>
    </div>
</div>

export const Dash: FC = () => {
    return <Page className="flex flex-col justify-center items-start">
        <div className="flex flex-col w-[60vw] max-md:w-[80vw] self-center items-center">
            <First />
            <Footer />
        </div>
    </Page>
}